import { render, staticRenderFns } from "./pricePrint.vue?vue&type=template&id=25283c37&scoped=true"
import script from "./pricePrint.vue?vue&type=script&lang=js"
export * from "./pricePrint.vue?vue&type=script&lang=js"
import style0 from "./pricePrint.vue?vue&type=style&index=0&id=25283c37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25283c37",
  null
  
)

export default component.exports